import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from '@contexts'
import { useToast } from '@contexts/ToastContext'
import storage from '@services/storage'
import { Loading } from '@components'

/**
 * Página dedicada para validação de e-mail.
 * Exibe a tela de carregamento "Validando e-mail" do início ao fim e realiza o redirecionamento.
 */
const EmailVerificationPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const { verifyEmail, isEmailVerified, loading } = useAuth()
  const { showToast } = useToast()
  const hasRun = useRef(false)
  const [isVerifying, setIsVerifying] = useState(true)

  const token = searchParams.get('verificationToken')

  useEffect(() => {
    // Se ainda estiver carregando os dados do usuário, aguarda para saber o status real de verificação
    if (loading) return

    if (token && !hasRun.current) {
      hasRun.current = true

      const performVerification = async () => {
        try {
          // Se o usuário já estiver verificado, avisa e não faz a requisição
          if (isEmailVerified) {
            showToast('Usuário já verificado', 'info')
          } else {
            await verifyEmail(token)
          }
        } finally {
          // Remove o token da URL usando setSearchParams para evitar chamadas duplicadas
          const params = new URLSearchParams(searchParams)
          params.delete('verificationToken')
          setSearchParams(params, { replace: true })

          setIsVerifying(false)

          // Redireciona o usuário
          const lastSelectedCitySlug = storage.getItem('lastSelectedCitySlug')
          if (lastSelectedCitySlug) {
            navigate(`/${lastSelectedCitySlug}`, { replace: true })
          } else {
            navigate('/', { replace: true })
          }
        }
      }

      performVerification()
    } else if (!token && !hasRun.current) {
      // Se não houver token na rota, redireciona diretamente
      hasRun.current = true
      setIsVerifying(false)
      const lastSelectedCitySlug = storage.getItem('lastSelectedCitySlug')
      if (lastSelectedCitySlug) {
        navigate(`/${lastSelectedCitySlug}`, { replace: true })
      } else {
        navigate('/', { replace: true })
      }
    }
  }, [token, searchParams, setSearchParams, verifyEmail, isEmailVerified, loading, showToast, navigate])

  return <Loading fullScreen={true} text="Validando e-mail" />
}

export default EmailVerificationPage
